import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { ProjectId } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { getProjectMembersQueryKey } from 'queries';
import { getProjectUsersLiteKey } from 'queries/common';
import {
  getPlaceholderResolutionByProjectQueryKeyV2,
  PlaceholderResolutionsQueryKey,
} from 'queries/placeholder';
import { useProjectWSUpdates } from '../use-project-ws-updates';

export const useProjectMembersWebsocket = ([, projectId]: ProjectId): void => {
  const queryClient = useQueryClient();
  const handleSocketUpdates = useCallback(async () => {
    await queryClient.invalidateQueries(ProjectId(projectId));
    await queryClient.invalidateQueries(
      getProjectMembersQueryKey(ProjectId(projectId)),
    );
    await queryClient.invalidateQueries(getProjectUsersLiteKey());
    await queryClient.invalidateQueries(
      getPlaceholderResolutionByProjectQueryKeyV2(ProjectId(projectId)),
    );
    await queryClient.invalidateQueries(PlaceholderResolutionsQueryKey);
  }, [projectId, queryClient]);

  useProjectWSUpdates(
    projectId,
    handleSocketUpdates,
    EventType(Action.Create, ObjectType.ProjectMembersV2),
  );
  useProjectWSUpdates(
    projectId,
    handleSocketUpdates,
    EventType(Action.Update, ObjectType.ProjectMembersV2),
  );
  useProjectWSUpdates(
    projectId,
    handleSocketUpdates,
    EventType(Action.Delete, ObjectType.ProjectMembersV2),
  );
};
